// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19.071 9H4.93C3.863 9 3 9.84 3 10.875v1.25C3 13.161 3.863 14 4.929 14H19.07c1.067 0 1.93-.84 1.93-1.875v-1.25C21 9.839 20.137 9 19.071 9z\" fill=\"currentColor\"/></svg>";
// Exports
module.exports = code;